import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import moment from "moment";
import RoomFacility from "../roomFacility/roomFacility";
import Customer from "../customer/customer";
import Exclusive from "../exclusive/exclusive";
import cardicon1 from "../../images/aboutUs/cardIcon.png";
import cardicon2 from "../../images/aboutUs/cardIcon2.png";
import cardicon3 from "../../images/aboutUs/cardIcon3.png";
import cardicon4 from "../../images/aboutUs/cardIcon4.png";
import "./booking.css";
import villa2 from "../../images/gallery/villa2.png";
import villa3 from "../../images/gallery/villa3.png";
import villa4 from "../../images/gallery/villa4.png";
import villa1 from "../../images/gallery/villa1.png";
import bed from "../../images/aboutUs/maskIcon1.png";
import bathroom from "../../images/aboutUs/maskIcon2.png";
import feet from "../../images/aboutUs/maskIocn3.png";
import car from "../../images/aboutUs/maskIcon4.png";
import BookingForm from "../bookigForm/bookingForm";
import { DatePicker, message } from "antd";
import "antd/dist/reset.css";
import UnderDevelopmentModal from "./UnderDevelopmentModal";

const Booking = () => {
  const { RangePicker } = DatePicker;
  const [dates, setDates] = useState(null);
  const [bookedDates, setBookedDates] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const location = useLocation();

  // Fetch existing bookings from the backend
  useEffect(() => {
    const fetchBookings = async () => {
      try {
        const response = await fetch("http://localhost:5002/api/bookings");
        if (!response.ok) {
          throw new Error("Failed to fetch bookings");
        }
        const data = await response.json();
        // Map the data to a format that's easy to work with
        const formattedDates = data.map(booking => ({
          start: moment(booking.checkIn).startOf('day'),
          end: moment(booking.checkOut).endOf('day'),
        }));
        setBookedDates(formattedDates);
      } catch (error) {
        console.error("Error fetching bookings:", error);
        message.error("Could not load booking information. Please try again later.");
      }
    };

    fetchBookings();
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const checkIn = params.get("checkIn");
    const checkOut = params.get("checkOut");
    if (checkIn && checkOut) {
      setDates([moment(checkIn, "YYYY-MM-DD"), moment(checkOut, "YYYY-MM-DD")]);
    }
  }, [location.search]);

  const handleDateChange = (value) => {
    setDates(value);
  };

  // Function to disable dates that are already booked or in the past
  const disabledDate = (current) => {
    // Disable past dates
    if (current && current < moment().startOf('day')) {
      return true;
    }

    // Disable booked dates
    for (const range of bookedDates) {
      if (current.isBetween(range.start, range.end, 'day', '[]')) {
        return true;
      }
    }

    return false;
  };

  const handleFormSubmit = () => {
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <div className="relative w-full md:min-h-screen h-[75%] ">
        {/* Background Image - Full Width */}
        <div className="absolute inset-0 w-full h-full  bg-cover bg-center bgBookingBanner z-0"></div>

        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-50 z-0"></div>

        {/* Content Wrapper */}
        <div className="relative z-10 flex flex-col items-center justify-center md:h-screen h-[700px] text-center text-white px-4">
          <div className="flex flex-col gap-4 md:w-[491px] md:h-[183px]  bg-white/15 backdrop-blur-[24px] p-8 rounded-[20px]">
            <div className="flex gap-3 justify-center">
              <div className="text-base poppins-medium">HOME</div>
              <div className="text-base poppins-medium">/</div>
              <div className="text-base poppins-medium">BOOKING</div>
            </div>
            <h2 className="text-3xl md:text-6xl font-normal ">BOOKING</h2>
          </div>
        </div>
      </div>
      <div className="mt-10">
        <div
          className="  text-white rounded-lg max-md:p-4 mt-10 mb-10"
          style={{ maxWidth: "1440px", margin: "auto" }}
        >
          {/* Main Content */}
          <div className="flex flex-col md:flex-row gap-12">
            {/* Left Side: Main Image */}
            <div className="md:w-[40%]">
              <img
                src={villa1}
                alt="Villa Interior"
                className="w-full  object-cover rounded-lg"
              />
              {/* Thumbnail Images */}
              <div className="flex justify-between mt-4">
                <img src={villa2} alt="thumb" className="w-[30%] rounded-lg" />
                <img src={villa3} alt="thumb" className=" w-[30%] rounded-lg" />
                <img src={villa4} alt="thumb" className=" w-[30%] rounded-lg" />
              </div>
            </div>

            {/* Right Side: Details */}
            <div className="md:w-[60%] md:space-y-8 space-y-4">
              <h3 className="text-[#585858] poppins-medium uppercase text-xl">
                GIR FOREST
              </h3>
              <h1 className="md:text-[46px] text-[28px] poppins-bold text-[#672220]">
                The Villa Gir Glades
              </h1>
              
              {/* Check Availability Button */}
              <div className="flex items-center space-x-4 bg-white rounded-full p-3 border border-gray-300 shadow-md w-[320px] md:w-[400px]">
                <RangePicker
                  className="w-full poppins-medium"
                  format="DD-MM-YYYY"
                  onChange={handleDateChange}
                  value={dates}
                  placeholder={["Check-in", "Check-out"]}
                  disabledDate={disabledDate}
                />
              </div>

              {/* Details */}
              <div className="bg-white   max-w-[414px] p-4 rounded-[16px] shadow-[0px_0px_20px_0px_#00000024] space-y-10">
                <div className="flex justify-between items-center">
                  <span className="flex   text-[#212121] poppins-regular text-base items-center gap-2 ">
                    <span>
                      <img src={bed} className="w-9 h-9" alt="bed" />
                    </span>
                    2 Super King-Size Bedrooms
                  </span>
                  <span className="flex text-[#212121] poppins-regular text-base  items-center gap-2 ml-4">
                    <span>
                      <img src={bathroom} className="w-9 h-9" alt="bathroom" />
                    </span>{" "}
                    2 Lavish Bathrooms
                  </span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="flex text-[#212121] poppins-regular text-base  items-center gap-2">
                    <span>
                      <img src={feet} className="w-9 h-9" alt="feet" />
                    </span>{" "}
                    1 Upper Deck Room
                  </span>
                  <span className="flex text-[#212121] poppins-regular text-base  items-center gap-2">
                    <span>
                      <img src={car} className="w-9 h-9" alt="car" />
                    </span>{" "}
                    Infinity Pool
                  </span>
                </div>
              </div>

              {/* Description */}
              <div>
                <h3 className="text-[#1a1a1a] poppins-semibold text-2xl mt-12">
                  About Gir Glades
                </h3>
                <p className="text-[#5A5A5A] text-xl poppins-regular leading-[40px] mt-1">
                  Experience the tranquil comforts of a luxury villa in Sasan
                  Gir, designed to meet your every need. Surrounded by greenery
                  and wildlife, Gir Glades offers a home that takes care of you
                  and your loved ones with luxurious amenities and home-cooked
                  meals.
                </p>
              </div>

              {/* CTAs */}
              <div className="mt-6">
                <p className="text-[#5A5A5A] text-xl poppins-regular leading-[40px] mt-1">
                  Or book through our trusted partners:
                </p>
                <div className="flex gap-4 mt-4">
                  <a
                    href="https://www.booking.com/hotel/in/gir-glades-talala.html"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition"
                  >
                    Book on Booking.com
                  </a>
                  <a
                    href="https://www.makemytrip.com/hotels/hotel-details/?hotelId=202503021714569836&_uCurrency=INR&checkin=07302025&checkout=07312025&city=CTGIRG&country=IN&lat=20.96881&lng=70.85628&locusId=RGGIRN&locusType=region&rank=1&regionNearByExp=3&roomStayQualifier=2e0e&rsc=1e2e0e&searchText=Gir+Glades&topHtlId=202503021714569836&mtkeys=undefined&isPropSearch=T"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-orange-500 text-white px-4 py-2 rounded-lg hover:bg-orange-600 transition"
                  >
                    Book on MakeMyTrip
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <BookingForm selectedDates={dates} onFormSubmit={handleFormSubmit} />
      <RoomFacility />
      <UnderDevelopmentModal visible={isModalVisible} onCancel={handleModalClose} />
    </>
  );
};

export default Booking;

